import React from 'react';
import MapPage from './MapPageLeaflet';
import {Paper} from 'material-ui';
import HomeMob from './HomeMob';
import {markers} from '../../libs/config';
import Notice from './Notice';
import NewsEvents from './NewsEvents';
import ImportantLinks from './ImportantLinks';
import CollapsiblePaper from '../common/CollapsiblePaper';
import TextTruncate from '../common/TextTruncate';
import MiniRainfallWatch from './MiniRainfallWatch';
import MiniRiverWatch from './MiniRiverWatch';

class Home extends React.Component {
  render() {
    const {mobView} = this.props;
    let style = {width: mobView ? '49%' : '100%'};
    return (
      <div className={mobView? '': 'inline-it'}>{
        mobView ?
          <HomeMob /> :
          <div className={'inline-it'} style={{maxWidth:'95%'}}>
            <div style={{width: mobView ? '100%' : '19%'}} className={mobView && 'inline-it'}>
              <CollapsiblePaper title="Notice" expand={true} containerHeight="406px" contentHeight="356px" style={style}>
                <Notice/>
              </CollapsiblePaper><br/>

              {/*<Paper zDepth={1} style={{...style, maxHeight: '406px'}}>*/}
              {/*/!*<h5 className="myTableHead">Notice Board</h5>*!/*/}
              {/*/!*<div style={{height: '358px', padding: '5px', overflowY: 'scroll', color: '#0f72a9'}}>*!/*/}
              {/*/!*<Notice/>*!/*/}
              {/*/!*</div>*!/*/}
              {/*</Paper>*/}


              <CollapsiblePaper title="News and Events" containerHeight="360px" contentHeight="320px" style={style}>
                <NewsEvents/>
              </CollapsiblePaper><br/>
              {/*<Paper zDepth={1} style={{...style, maxHeight: '360px'}}>*/}
              {/*<h5 className="myTableHead">News and Events</h5>*/}
              {/*<div style={{height: '315px', overflowY: 'scroll'}}>*/}
              {/*<NewsEvents/>*/}
              {/*</div>*/}
              {/*</Paper><br/>*/}

              <CollapsiblePaper title="Important Links" containerHeight="406px" contentHeight="356px" style={style}>
                <ImportantLinks/>
              </CollapsiblePaper><br/>
              {/*<Paper zDepth={1} style={{...style, maxHeight: '406px'}}>*/}
              {/*<h5 className="myTableHead">Important Links</h5>*/}
              {/*<div style={{height: '358px', padding: '5px', overflowY: 'scroll'}}>*/}
              {/*<ImportantLinks/>*/}
              {/*</div>*/}
              {/*</Paper>*/}


              <Paper zDepth={1} style={{...style, height: '240px'}}>
                <h5 className="myTableHead">NWP Products</h5>
                <a href='http://mfd.gov.np/nwp/' target="_blank" rel="noopener noreferrer" className="inline-it"
                   style={{marginTop: '5px', height:'74%', overflowY:'hidden'}}>
                  <img src={markers.nwp} alt="not found" className="img-responsive"
                       style={{...style, height: '137%', width: '190px'}}/>
                </a>
              </Paper>
            </div>
            <br/>

            <div style={{width: '60%'}} className="">
              <MapPage style={{width: '100%'}}/><br/>
              <Paper style={{width: '100%', textAlign: 'justify', padding: '5px', overflowY: 'scroll'}} zDepth={1}>
                <TextTruncate text={`The Centre of Hydrology and Water Resources Research (CHWRR) (जल विज्ञान तथा जलस्रोत अनुसन्धान केन्द्र) is a Government of Nepal institution under the Water and Energy Commission Secretariat (WECS), located in Babarmahal, Kathmandu. CHWRR is dedicated to hydrological, cryosphere, and water resources research, monitoring, real-time data management, forecasting, and innovation to support sustainable, climate-resilient water management across Nepal.
Core Mandate & Objectives
•	Hydrological & Cryospheric Data & Early Warning: Generating and disseminating real-time hydrological and cryospheric data to strengthen flood forecasting, cryospheric multi-hazard assessments and early warning services.
•	System & Cryosphere Research: Conducting scientific research on rivers, groundwater, springs, glaciers, glacial lakes, seasonal snow cover, and complex cryospheric interactions.
•	National Laboratory Testing & Physical Modeling: Operating national-level testing facilities-including river flow simulation channels, steep-slope debris flow/landslide models, and soil and material testing laboratories-to analyze disaster dynamics, water quality, and hydraulic structures.
•	National Center of Excellence: Advancing evidence-based decision-making and building technical capacity in hydrology and cryospheric science.`}/>
              </Paper>
            </div>

            <br/>

            <div style={{width: '19%'}}>
              <MiniRiverWatch/><br/>
              <MiniRainfallWatch/><br/>
              <Paper zDepth={1} style={{height: 'inherit'}}>
                <h5 className="myTableHead">Weather Forecast</h5>
                <a href="http://mfd.gov.np" target="_blank" rel="noopener noreferrer"
                   style={{...style, height: '120px'}} className="inline-it">
                  <img className="img-responsive" src={markers.mfd} alt="not found" style={{maxHeight: '120px'}}/>
                </a>
              </Paper>
            </div>
          </div>
      }</div>
    );
  }
}

export default Home;



// WEBPACK FOOTER //
// ./src/components/Home/Home.js